<template>
  <div>
    <HeadNav :title="headNavImg.title" :titleEn="headNavImg.profiles" :src="headNavImg.picture"></HeadNav>
    <div class="newNav animated fadeIn">
      <div class="newNavCont">
        <div @click="getIndex(1)" :class="{activeBg:conpanyActive}">公司介绍</div>
        <div @click="getIndex(2)" :class="{activeBg:historyActive}">发展历程</div>
      </div>
    </div>
    <!-- 公司介绍 -->
    <div class="compPro" :id="historyActive ? 'activeShow' : ''">
      <div class="content">
        <div class="profileTitleParent">
          <Title title="公司简介" titleEn="PROFILE"></Title>
        </div>
        <div class="profileParent">
          <div v-html="detailProfile" class="mobileEditorAbout"></div>
          <div class="rightImg"><img src="../assets/imgProfile1.png" alt=""></div>
          
          <!-- <div class="rightPic">
            <el-row class="address">
              <div class="txxPic">
                <div class="imgCont">
                  <img :src="require('../assets/北京.png')" alt width="100%" />
                </div>
              </div>
              <div class="txxPic">
                <div class="imgCont">
                  <img :src="require('../assets/上海.png')" alt width="100%" />
                </div>
              </div>
              <div class="txxPic">
                <div class="imgCont">
                  <img :src="require('../assets/合肥.jpg')" alt width="100%" />
                </div>
              </div>
              <div class="txxPic">
                <div class="imgCont">
                  <img :src="require('../assets/成都.png')" alt width="100%" />
                </div>
              </div>
            </el-row>
          </div>
          <div class="imgProfile">
            <div class="contBox"><img src="../assets/imgProfile1.png" alt=""></div>
            <div class="contBox"> <img src="../assets/imgProfile2.png" alt=""></div>
          </div> -->
        </div>
        <div class="botImg">
          <div class="txxPic">
            <img :src="require('../assets/about.jpg')" alt width="100%" />
          </div>
          <div class="txxPic">
            <img :src="require('../assets/beijing_door.jpg')" alt width="100%" />
          </div>
          <div class="txxPic">
            <img :src="require('../assets/hefei_door.jpg')" alt width="100%" />
          </div>
          <div class="txxPic">
            <img :src="require('../assets/chengdu_door.jpg')" alt width="100%" />
          </div>
          <div class="txxPic">
            <img :src="require('../assets/shenzhen_door.jpg')" alt width="100%" />
          </div>
          <div class="txxPic">
            <img :src="require('../assets/zhuhai_door.jpg')" alt width="100%" />
          </div>
           <div class="txxPic">
            <img :src="require('../assets/hangzhou_door.jpg')" alt width="100%" />
          </div>
        </div>
        <!-- <el-divider class="lineBot">
          <i class="el-icon-caret-bottom"></i>
        </el-divider> -->
        <!-- <el-row :gutter="20" class="address">
          <el-col :span="6" style='overflow: hidden;height: 300px;'>
            <div class="imgCont">
              <img :src="require('../assets/北京.png')" alt width="100%" />
            </div>
            <div class="cityName">北京</div>
          </el-col>
          <el-col :span="6" style='overflow: hidden;height: 300px;'>
            <div class="imgCont">
              <img :src="require('../assets/上海.png')" alt width="100%" />
            </div>
            <div class="cityName">上海</div>
          </el-col>
          <el-col :span="6" style='overflow: hidden;height: 300px;'>
            <div class="imgCont">
              <img :src="require('../assets/合肥.jpg')" alt width="100%" />
            </div>
            <div class="cityName">合肥</div>
          </el-col>
          <el-col :span="6" style='overflow: hidden;height: 300px;'>
            <div class="imgCont">
              <img :src="require('../assets/成都.png')" alt width="100%" />
            </div>
            <div class="cityName">成都</div>
          </el-col>
        </el-row> -->
        <!-- mobile公司轮播 -->
        <el-carousel :interval="5000" height="240px" indicator-position="outside" class="CompanyMobile" loop>
          <el-carousel-item>
            <img :src="require('../assets/imgProfile1.png')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/about.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/beijing_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/hefei_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/chengdu_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/shenzhen_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/zhuhai_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
          <el-carousel-item>
            <img :src="require('../assets/hangzhou_door.jpg')" alt width="100%" height="230px" />
          </el-carousel-item>
        </el-carousel>
      </div>
    
      <div class="Honor">
        <div class="HonorPc">
          <div class="honorParent">
            <div>CERTIFICATE</div>
            <div>荣誉证书</div>
            <div class="titleLine2"></div>
          </div>
          <!-- 流式轮播 -->
          <div class="devices">
            <ul class="devicesUl" ref="devicesUl">
              <li v-for="item in honorList" :key="item">
                <img :src="item" alt />
              </li>
              <li v-for="item in honorList" :key="item">
                <img :src="item" alt />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Title title="联系我们" titleEn="CONTACT"></Title>
      <div @click="typeChange">
        <!-- <el-row style="margin:50px auto 0;width:1190px;" class="ContactPc">
          <el-col :span="11">
            <div :class="{ ContactDiv:true,onload:this.index == 0 ? true : false}" data-type="0">
                <span class="comTitle">上海聚跃检测技术有限公司<br />(总部 · 浦东实验室）</span>
                <br />Tel：021-58372276 / 021-58371836
                <br />E-mail:fib_sh@fibtek.com.cn
                <br />Http://www.fibtek.com.cn
                <br />上海市浦东新区张东路1388号2幢
            </div>
          </el-col>
          <el-col :span="11" :offset="2">
            <div :class="{ ContactDiv:true,onload:this.index == 1 ? true : false}" data-type="1">
              <span class="comTitle">上海聚跃检测技术有限公司<br />(浦西实验室）</span>
              <br />Tel：021-54661507
              <br />E-mail：fib_sh@fibtek.com.cn
              <br />Http://www.fibtek.com.cn
              <br />上海市徐汇区虹梅路1682号
            </div>
          </el-col>
        </el-row> -->
        <el-row style="margin:50px auto 0;width:1190px;" class="ContactPc">
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 0 ? true : false}" data-type="0">
              <span class="comTitle">上海聚跃检测技术有限公司 <br />(总部 · 浦东实验室)</span>
              <br />Tel：021-58372276 / 021-58371836
              <br />E-mail:fib_sh@fibtek.com.cn
              <br />Http://www.fibtek.com.cn
              <br />上海市浦东新区张东路1388号2号楼
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 1 ? true : false}" data-type="1">
              <span class="comTitle">上海聚跃检测技术有限公司<br />(浦西实验室)</span>
              <br />Tel：021-54661507
              <br />E-mail：fib_sh@fibtek.com.cn
              <br />Http://www.fibtek.com.cn
              <br />上海市徐汇区虹梅路1682号
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 2 ? true : false}" data-type="2">
              <span class="comTitle">北京聚跃检测技术有限公司 <br />(北京实验室)</span>
              <br />Tel：010-62987887
              <br />E-mail: fib_bj@fibtek.com.cn
              <br />北京市海淀区上地七街国际创业园金远见大厦一楼108室
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 3 ? true : false}" data-type="3">
              <span class="comTitle">合肥聚跃检测技术有限公司<br />(合肥实验室)</span>
              <br />Tel：0551-65310036
              <br />E-mail: fib_hf@fibtek.com.cn
              <br />合肥市高新区创新产业园二期G2 A座1F
            </div>
          </div>
        </el-row>
        <el-row style="margin:50px auto 0;width:1190px;" class="ContactPc">
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 4 ? true : false}" data-type="4">
              <span class="comTitle">成都聚跃检测技术有限公司<br />(成都实验室)</span>
              <br />Tel：028-87099007
              <br />E-mail: fib_cd@fibtek.com.cn
              <br />四川省成都市高新区天府大道北段1480号成都高新孵化园5号楼116
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 5 ? true : false}" data-type="5">
              <span class="comTitle">深圳聚跃检测技术有限公司<br />(深圳实验室)</span>
              <br />Tel：0755-86955112
              <br />E-mail: fib_sz@fibtek.com.cn
              <br />深圳市宝安区新安街道兴东社区67区大仟工业厂区2号厂房1层03
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 6 ? true : false}" data-type="6">
              <span class="comTitle">珠海聚跃检测技术有限公司<br />(珠海实验室)</span>
              <br />Tel：0756-8858818
              <br />E-mail: fib_zh@fibtek.com.cn
              <br />广东省珠海市香洲区唐家湾镇新沙三路188号华发国际产业园A12栋1单元101号
            </div>
          </div>
          <div class="addressItem">
            <div :class="{ ContactDiv:true,onload:this.index == 7 ? true : false}" data-type="7">
              <span class="comTitle">杭州聚跃检测技术有限公司<br />(杭州实验室)</span>
              <br />Tel：0571-86607578
              <br />E-mail: fib_hz@fibtek.com.cn
              <br />杭州市滨江区联慧街88号联慧科创中心C座1楼C09-10
            </div>
          </div>
        </el-row>
      </div>
      <!-- 地址轮播 -->
      <el-carousel
        :interval="4000"
        indicator-position="outside"
        class="ContactMobile"
        height="200px"
        @change="CompanyMobile"
        @setActiveItem="CompanyMobile"
        loop
      >
      <el-carousel-item class="ContactMobileDiv">
        <div>
          上海聚跃检测技术有限公司<br/>(浦东实验室）
          <br />Tel：021-58372276 / 021-58371836
          <br />E-mail：fib_sh@fibtek.com.cn
          <br />Http://www.fibtek.com.cn
          <br />上海市浦东新区张东路1388号2号楼
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          上海聚跃检测技术有限公司<br />(浦西实验室）
          <br />E-mail：fib_sh@fibtek.com.cn
          <br />Http://www.fibtek.com.cn
          <br />上海市徐汇区虹梅路1682号
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          北京聚跃检测技术有限公司 <br />(北京实验室)
          <br />Tel：010-62987887
          <br />E-mail: fib_bj@fibtek.com.cn
          <br />北京市海淀区上地七街国际创业园金远见大厦一楼108室
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          合肥聚跃检测技术有限公司<br />(合肥实验室)
          <br />Tel：0551-65310036
          <br />E-mail: fib_hf@fibtek.com.cn
          <br />合肥市高新区创新产业园二期G2 A座1F
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          成都聚跃检测技术有限公司<br />(成都实验室)
          <br />Tel：028-87099007
          <br />E-mail: fib_cd@fibtek.com.cn
          <br />四川省成都市高新区天府大道北段1480号成都高新孵化园5号楼116
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          深圳聚跃检测技术有限公司<br />(深圳实验室)
          <br />Tel：0755-86955112
          <br />E-mail: fib_sz@fibtek.com.cn
          <br />深圳市宝安区新安街道兴东社区67区大仟工业厂区2号厂房1层03
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          珠海聚跃检测技术有限公司<br />(珠海实验室)
          <br />Tel：756-8858818
          <br />E-mail: fib_zh@fibtek.com.cn
          <br />广东省珠海市香洲区唐家湾镇新沙三路188号华发国际产业园A12栋1单元101号
        </div>
      </el-carousel-item>
      <el-carousel-item class="ContactMobileDiv">
        <div>
          杭州聚跃检测技术有限公司<br />(杭州实验室)
          <br />Tel：0571-86607578
          <br />E-mail: fib_hz@fibtek.com.cn
          <br />杭州市滨江区联慧街88号联慧科创中心C座1楼C09-10
        </div>
      </el-carousel-item>
      </el-carousel>
      <div class="map">
        <!-- 百度地图 -->
        <baidu-map class="bm-view" :center="position1" :zoom="zoom">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
          <bm-info-window :position="position1" title="公司地址" show>
            <p>{{address1}}</p>
          </bm-info-window>
        </baidu-map>
      </div>
      <div class="mapMobile">
        <!-- 百度地图 -->
        <baidu-map class="bm-view" :center="position" :zoom="zoom">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-geolocation
            anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
            :showAddressBar="true"
            :autoLocation="true"
          ></bm-geolocation>
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
          <!-- <bm-info-window :position="position" title="公司地址" show>
            <p>{{address}}</p>
          </bm-info-window> -->
        </baidu-map>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="compHistory" :id="conpanyActive ? 'activeShow' : ''">
        <div class="companyHistCont">
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2012</span>
            <span class="animated bounceInRight">聚跃检测成立于上海漕河泾开发区。</span>
          </div>
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2013</span>
            <span class="animated bounceInRight">成立成都聚跃检测子公司并自建实验室，专注于服务西南部和西北地区客户。</span>
          </div>
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2016</span>
            <span class="animated bounceInRight">成立北京聚跃检测子公司并自建实验室，专注于服务华北和东北地区客户。</span>
          </div>
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2017</span>
            <span class="animated bounceInRight">成立合肥聚跃检测子公司并自建实验室，在合肥高新区建立“合肥集成电路失效分析检测公共技术服务平台”，专注于服务中部地区客户。</span>
          </div>
          <!-- <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2018</span>
            <span class="animated bounceInRight">聚跃与中国科学技术大学先进技术研究院签订校企合作项目，服务领域扩展到微纳研究与制造。</span>
          </div> -->
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2019</span>
            <span class="animated bounceInRight">聚跃检测与专业的集成电路分析设计服务提供商北京万芯科技有限公司战略合作，帮助企业了解世界先进设计和制程技术、缩短研发周期、助力集成电路产业快速发展。</span>
          </div>
          <div class="historyMessage">
            <span class="animated fadeIn"></span>
            <span><div class="smallCircle"></div></span>
            <span class="animated fadeIn">2020</span>
            <span class="animated bounceInRight">上海浦东综合性实验室建成并投入使用，为客户提供“一站式”检测分析服务。</span>
          </div>
          <div class="line"></div>
        </div>
        <!-- 新历史 -->
        <div class="newHistory">
          <TimelineCarousel :timelineData="timelineData" />
        </div>
        <!-- <div class="historyCont">
          <img src="../assets/history1.png" alt="" class="historyImg1">
          <img src="../assets/history22.png" alt="" class="historyImg2">
          <div class="historyTxtCont">
            <div class="historyTxt">
              <div class="year">2012</div>
              <div class="detail">聚跃检测成立于上海漕河泾开发区。</div>
            </div>
            <div class="historyTxt">
              <div class="year">2013</div>
              <div class="detail">成立成都聚跃检测分公司并自建实验室，<br/>专注于服务西南部和西北地区客户。</div>
            </div>
             <div class="historyTxt">
              <div class="year">2016</div>
              <div class="detail">成立北京聚跃检测分公司并自建实验室，<br/>专注于服务华北和东北地区客户。</div>
            </div>
             <div class="historyTxt">
              <div class="year">2017</div>
              <div class="detail">成立合肥聚跃检测分公司并自建实验室，在合肥高新区建立<br/>“合肥集成电路失效分析检测公共技术服务平台”，专注于服务中部地区客户。</div>
            </div>
            <div class="historyTxt">
              <div class="year">2018</div>
              <div class="detail">聚跃与中国科学技术大学先进技术研究院签订校企合作项目，<br/>服务领域扩展到微纳研究与制造。</div>
            </div>
            <div class="historyTxt">
              <div class="year">2019</div>
              <div class="detail">聚跃检测与专业的集成电路分析设计服务提供商<br/>北京万芯科技有限公司战略合作，帮助企业了解世界先进设计和制程技术、<br/>缩短研发周期、助力集成电路产业快速发展。</div>
            </div>
            <div class="historyTxt">
              <div class="year">2020</div>
              <div class="detail">上海浦东综合性实验室建成并投入使用，为客户提供“一站式”检测分析服务。</div>
            </div>
          </div>
        </div> -->
    </div>
    <!-- 发展历程mobile -->
    <div class="mobileCompHistor" :id="conpanyActive ? 'activeShow' : ''">
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2012</span>
        <span class="animated bounceInRight">聚跃检测成立于上海漕河泾开发区</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2013</span>
        <span class="animated bounceInRight">成立成都子公司，专注于服务西南部和西北地区客户</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2016</span>
        <span class="animated bounceInRight">成立北京子公司，专注于服务华北和东北地区客户</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2017</span>
        <span class="animated bounceInRight">成立合肥子公司，建立“合肥集成电路失效分析检测公共技术服务平台”，专注于服务中部地区客户</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2018</span>
        <span class="animated bounceInRight">与中国科技大学先进技术研究院签订校企合作项目，服务领域扩展到微纳研究与制造</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2019</span>
        <span class="animated bounceInRight">与北京万芯科技有限公司达成战略合作，帮助企业了解世界先进设计和制程技术、缩短研发周期助力集成电路产业快速发展</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2020</span>
        <span class="animated bounceInRight">成立深圳子公司，上海浦东综合性实验室建成并投入使用，为客户提供“一站式”检测分析服务</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2022</span>
        <span class="animated bounceInRight">聚跃10周年，迎来2.0发展</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2023</span>
        <span class="animated bounceInRight">“漕河泾汽车电子综合测试平台”运行，成立珠海子公司，成立北京中科聚微子公司</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2024</span>
        <span class="animated bounceInRight">完成A轮融资，长三角基地筹建</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2025</span>
        <span class="animated bounceInRight">完成A+轮融资，成立杭州子公司，获得国家级专精特新小巨人认定</span>
      </div>
      <div class="historyMessage">
        <span class="animated fadeIn"></span>
        <span><div class="smallCircle"></div></span>
        <span class="animated fadeIn">2026</span>
        <span class="animated bounceInRight">......</span>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>
<script>
import TimelineCarousel from '../components/TimelineCarousel.vue'
import HeadNav from "../components/head.vue";
import Title from "../components/title.vue";
import { getCompany, getTheme } from "../api/allApiRequest.js";
export default {
  name: "about",
  data() {
    return {
      zoom: 16,
      positionList: [
        {
          lng: 121.638465,
          lat: 31.224559,
          address: "上海市浦东新区张东路1388号2号楼"
        },
        {
          lng: 121.407718,
          lat: 31.171531,
          address: "上海市徐汇区虹梅路1682号"
        },
        {
          lng: 116.310201,
          lat: 40.052827,
          address: "北京市海淀区上地七街国际创业园金远见大厦一楼108室"
        },
        {
          lng: 117.142448,
          lat: 31.842627,
          address: "合肥市高新区创新产业园二期G2 A座1F"
        },
        {
          lng: 104.069323,
          lat: 30.579133,
          address: "四川省成都市高新区天府大道北段1480号成都高新孵化园5号楼116"
        },
        {
          lng: 113.920128,
          lat: 22.589550,
          address: "深圳市宝安区新安街道兴东社区67区大仟工业厂区2号厂房1层03"
        },
        {
          lng: 113.544774,
          lat: 22.409630,
          address: "广东省珠海市香洲区唐家湾镇新沙三路188号华发国际产业园A12栋1单元101号"
        },
        {
          lng: 120.237343,
          lat: 30.215870,
          address: "杭州市滨江区联慧街88号联慧科创中心C座1楼C09-10"
        }
      ],
      address: "",
      position: { lng: 121.638465, lat: 31.224559 },
      address1: "",
      position1: { lng: 121.638465, lat: 31.224559 },
      index: 0,
      detailProfile: "",
      honorList: [],
      headNavImg: {},
      value: 0,
      devicesUlDS:'',
      historyActive:false,  //谁显示
      conpanyActive:true,
      userId:"",
      timelineData: [
        {
          year: '2012',
          title: '聚跃检测成立于',
          desc: '上海漕河泾开发区'
        },
        {
          year: '2013',
          title: '成立成都子公司',
          desc: '专注于服务西南部和西北地区客户'
        },
        {
          year: '2016',
          title: '成立北京子公司',
          desc: '专注于服务华北和东北地区客户'
        },
        {
          year: '2017',
          title: '成立合肥子公司',
          desc: '建立“合肥集成电路失效分析检测公共技术服务平台”<br/>专注于服务中部地区客户'
        },
        {
          year: '2018',
          title: '与中国科技大学先进技术研究院签订校企合作项目',
          desc: '服务领域扩展到微纳研究与制造'
        },
        {
          year: '2019',
          title: '与北京万芯科技有限公司达成战略合作',
          desc: '帮助企业了解世界先进设计和制程技术、缩短研发周期助力集成电路产业快速发展'
        },
        {
          year: '2020',
          title: '成立深圳子公司',
          desc: '上海浦东综合性实验室建成并投入使用<br/>为客户提供“一站式”检测分析服务'
        },
        {
          year: '2022',
          title: '聚跃10周年',
          desc: '迎来2.0发展'
        },
        {
          year: '2023',
          title: '“漕河泾汽车电子综合测试平台”运行',
          desc: '成立珠海子公司<br/>成立北京中科聚微子公司'
        },
        {
          year: '2024',
          title: '完成A轮融资',
          desc: '长三角基地筹建'
        },
        {
          year: '2025',
          title: '完成A+轮融资，成立杭州子公司',
          desc: '获得国家级专精特新小巨人认定'
        },
        {
          year: '2026',
          title: '......',
          desc: ''
        }
      ],
    };
  },
  components: {
    HeadNav,
    Title,
    TimelineCarousel
  },
  mounted() {
    this.getThemeHead();
    this.position = {
      lng: this.positionList[0].lng,
      lat: this.positionList[0].lat
    };
    this.address = this.positionList[0].address;
    this.position1 = {
      lng: this.positionList[0].lng,
      lat: this.positionList[0].lat
    };
    this.address1 = this.positionList[0].address;
    this.getCompanyList();
  },
  created(){
    this.key = location.hash.split("?")[1]
      ? location.hash.split("?")[1].split('&')[1].split("=")[1]
      : 0;
   if(this.key == 1){
        this.conpanyActive = true;
        this.historyActive = false;
      }else{
        this.conpanyActive = false;
        this.historyActive = true;
      }
  },
  methods: {
    CompanyMobile(e) {
      this.position = {
        lng: this.positionList[e].lng,
        lat: this.positionList[e].lat
      };
      this.address = this.positionList[e].address;
    },
    getLeft() {
      let width = this.$refs.devicesUl.offsetWidth;
      // console.log(width)
      let devicesUl = this.$refs.devicesUl;
    this.$refs.devicesUl.onmouseover = ()=>{
         clearInterval(this.devicesUlDS)
      }
      this.$refs.devicesUl.onmouseout = ()=>{
        let devicesUl = this.$refs.devicesUl;
        this.devicesUlDS = setInterval(() => {
        if (width / 2 <= Math.abs(devicesUl.offsetLeft)) {
          devicesUl.style.left = "0px";
        }
        devicesUl.style.left = devicesUl.offsetLeft - 1 + "px";
      }, 16);
      }
     this.devicesUlDS = setInterval(() => {
        if (width / 2 <= Math.abs(devicesUl.offsetLeft)) {
          devicesUl.style.left = "0px";
        }
        devicesUl.style.left = devicesUl.offsetLeft - 1 + "px";
      }, 16);
    },
    typeChange(e) {
      this.index = e.target.dataset.type;
      this.position1 = {
        lng: this.positionList[this.index].lng,
        lat: this.positionList[this.index].lat
      };
      this.address1 = this.positionList[this.index].address;
    },
    getCompanyList() {
      getCompany().then(res => {
        this.detailProfile = res.data.detailedContent;
        let honorList = res.data.qualification.split(",");
        let arr2 = []
        honorList.forEach(item => {
          arr2.push(process.env.VUE_APP_WEB_URL + item);
        });
        honorList.forEach(item => {
          arr2.push(process.env.VUE_APP_WEB_URL + item);
        });
         this.honorList = arr2
        setTimeout(() => {
          this.getLeft();
        }, 500);
      });
    },
     //主题返现
    getThemeHead() {
      getTheme({
        themeType: 1
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    },
    getIndex(index){
      switch (index){
        case 1:
            this.conpanyActive = true;
            this.historyActive = false;
          break;
        case 2:
            this.conpanyActive = false;
            this.historyActive = true;
          break;
        default:
            this.conpanyActive = true;
            this.historyActive = false;
          break;
      }
    }
  },
   watch:{
    $route(){
      this.userId= this.$route.query.id
    },
    userId() {
      if(this.userId == 1){
        this.conpanyActive = true;
        this.historyActive = false;
      }else{
        this.conpanyActive = false;
        this.historyActive = true;
      }
    }
  }
};
</script>
<style scoped>
.rightImg{
  width:32%;
  margin-left:1%;
  margin-top:2%;
  margin-bottom:3%;
  overflow: hidden;
}
.rightImg img,.botImg .txxPic img{
  height: 100%;
  width:100%;
}
.botImg{
  margin-bottom:50px;
  display: flex;
  justify-content: space-between;
}
.botImg .txxPic{
  width:14%;
  overflow: hidden;
}
#activeShow{
  display: none;
}
.newNav .activeBg{
  background: #248ECC;
  opacity: 1;
}
.newNav{
  height: 60px;
  width:100%;
  background:rgba(8,103,200,0.75);
  color:#fff;
  position: absolute;
  top:460px;
  left:0;
  font-size: 20px;
  font-weight: bold;
}
.newNavCont{
  width:1190px;
  height: 85px;
  margin:0 auto;
}
.newNavCont div{
  float: left;
  width: 200px;
  height:60px;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
}

.profileParent{
  display: flex;
  justify-content: space-between;
  position: relative;
}
.imgProfile{
  position:absolute;
  top:370px;
  height:337px;
  width: 73%;
}
.imgProfile .contBox{
  float:left;
  height: 100%;
  width:48%;
  overflow: hidden;
}
.imgProfile img{
  height: 100%;
  width:100%;
}
.imgProfile .contBox:nth-child(2){
  margin-left:4%;
}
.mobileEditorAbout{
  width:65%;
  line-height:32px;
}
.rightPic{
  margin-top:20px;
  height: 713px;
  width:23%;
}
.honorParent{
  padding-top: 40px;
  line-height: 42px;
}
.honorParent div{
  color:#fff;
  font-size: 26px;
  text-align: center;
  font-weight: 800;
}
.honorParent div:nth-child(1){
  font-size: 40px;
  opacity: 0.2;
}
.honorParent div:nth-child(2){
  line-height: 28px;
}
.honorParent .titleLine2{
  background:#fff;
  height: 4px;
  width:50px;
  margin:10px auto 0;
}
.ContactDiv {
  height: 180px;
  padding: 22px 30px;
  /* display: flex; */
  /* align-items: center; */
  cursor: pointer;
  border:1px solid #BFBFBF;
  font-size: 14px;
  line-height: 24px;
  transition: all 0.5s ease;
}
.ContactDiv:hover{
  box-shadow: 5px 8px 10px 0px rgba(43, 48, 52, 0.3);
  transition: all 0.5s ease;
}
.ContactDiv span.comTitle{
  font-size:18px;
  display: inline-block;
  margin-bottom: 10px;
}
.onload {
  box-shadow: 5px 8px 10px 0px rgba(43, 48, 52, 0.3);
  background-color: rgba(65, 120, 190, 1);
  color:#fff;
}
.devices {
  height: 250px;
  position: relative;
  overflow: hidden;
  padding:50px 0 ;
}
.devicesUl {
  height: 250px;
  list-style: none;
  position: absolute;
  white-space: nowrap;
  left: 0;
  list-style: none;
  padding:0;
  margin: 0;
}
.devicesUl li {
  display: inline-block;
  height: 100%;
  margin: 0 30px;
}
.devicesUl li img {
  height: 100%;
}
.ContactMobile {
  display: none;
}
.CompanyMobile {
  display: none;
}
.content {
  margin: 0 auto;
  width: 1190px;
}
.title {
  font-size: 28px;
  color: #053b7b;
  text-align: center;
  font-weight: 800;
}

.Marigin {
  margin-top: 50px;
}

.titleMarigin {
  margin-top: 10px;
}
.address{
  height: 100%;
}
.address .txxPic{
  height: 25%;
}
.address div.imgCont{
  /* height: 250px; */
  height: 85%;
  width: 100%;
  overflow: hidden;
} 
.address img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.address div.cityName {
  height:20%;
  text-align: center;
  font-size: 20px;
  color: #053b7b;
  margin-top: 3%;
}
.Honor {
  background:url(../assets/line.png) repeat center;
  /* background-size:contain ; */
  background-color: #4178be;
  /* margin-top:65px; */
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.bm-view {
  width: 100%;
  height: 100%;
}
.map {
  margin: 50px auto 0;
  width: 1190px;
  height: 400px;
}
.mapMobile {
  display: none;
}
.HonorPc {
  margin: 0 auto;
  width: 1190px;
}
.address img,.botImg .txxPic img,.profileParent img{
  transition: all 2s;
}
.address img:hover,.botImg .txxPic img:hover,.profileParent img:hover{
  transform: scale(1.4);
}

/* 公司历史 */
.compHistory{
  height: 100%;
}
.compHistory .companyHistCont{
  width: 1090px;
  margin:80px auto 80px;
  position: relative;
  padding-left:100px;
  display:none;
}
.mobileCompHistor .line{
  height: 1100px;
  width:2px;
  background:#ECECEC;
  position:absolute;
  top:0;
  left:26px;
  z-index: -1;
}
.historyMessage{
  display: flex;
  margin-top:35px;
}
.historyMessage span:nth-child(1){
  display:inline-block;
  color:#444;
  font-weight:bold;
  font-size:16px;
  width:0px;
}
.historyMessage span:nth-child(2){
  display:inline-block;
  height: 24px;
  width: 24px;
  margin:0 15px;
  background-color:#cdd8e5;
  opacity: 0.8;
  border-radius: 50%;
}
.historyMessage span:nth-child(2) .smallCircle{
  height: 12px;
  width: 12px;
  margin:6px;
  background-color:#0b62c2;
  border-radius: 50%;
}
.historyMessage span:nth-child(4),.historyMessage span:nth-child(3){
  display:inline-block;
  color:#666;
  font-weight:bold;
  font-size:15px;
}
/* .historyMessage .enlarge{
  transition: all 0.5s linear;
  cursor: pointer;
}
.historyMessage .enlarge:hover{
  transform: scale(1.2);
} */
.historyMessage span:nth-child(3){
  color:#FFA60F;
  margin-right:15px;
}
.companyHistCont .triangle{
  height: 34px;
  width: 58px;
  background: url(../assets/triangle.png) no-repeat center;
  background-size: 100%;
  margin:0 0 40px 97px;
}
.lineBot{
  display:none;
}
.profileTitleParent .pc{
    margin: 40px 30px 20px;
}
.CompanyMobile img,.profileParent img{
  object-fit: fill!important;
}

/* 历史 */
.historyCont{
  height: 900px;
  width:1190px;
  margin:50px auto 60px;
  position: relative;
}
.historyCont .historyImg2{
    /* margin-top: 60px;
    margin-left: 123px;
    height: 88%; */
    margin-top: 60px;
    margin-left: 87px;
    height: 75%;
}
.historyCont .historyImg1{
  height:30%;
  position: absolute;
  top:425px;
}
.historyTxtCont{
  position: absolute;
  top:0;
  right:0;
  text-align: right;
  padding:23px 76px 0 0;
}
.historyTxtCont .year{
  color:#ffa100;
  font-size:36px;
  font-family: Arial;
  font-style: italic;
  transition: all 0.5s linear;
}
.historyTxtCont .detail{
  font-size:14px;
  margin-top:15px;
  transition: all 0.5s linear;
  cursor: pointer;
}
.historyTxt:hover .detail{
  transform: scale(1.2);
}
.historyTxt:hover .year{
  transform: scale(0.8);
}
.historyTxtCont .historyTxt:nth-child(2){
  margin-top:24px;
}
.historyTxtCont .historyTxt:nth-child(3){
  margin-top:39px;
}
.historyTxtCont .historyTxt:nth-child(4){
  margin-top:20px;
}
.historyTxtCont .historyTxt:nth-child(5){
  margin-top:49px;
}
.historyTxtCont .historyTxt:nth-child(6){
  margin-top:32px;
}
.historyTxtCont .historyTxt:nth-child(7){
  margin-top:44px;
}
.mobileCompHistor{
  display: none;
  position: relative;
}
.ContactPc{
  /* display: flex;
  justify-content:space-between ; */
}
.ContactPc .addressItem{
  width:24%;
  float:left;
  margin-right:1.3%;
}
.ContactPc .addressItem:nth-child(4){
  margin-right: 0;
}
@media screen and (max-width: 750px) {
  .profileTitleParent .pc{
    margin: 30px 15px 0;
  }
  .lineBot,.mobileCompHistor{
    display:block;
  }
  .rightPic,.historyCont{
    display:none;
  }
  .mobileEditorAbout{
    width:100%;
  }
  .devices {
    height: 240px;
    padding:0;
  }
  .honorParent div{
    font-size: 14px;
  }
  .devicesUl {
    height: 200px;
    margin:20px 0;
  }
  .honorParent{
    padding-top:30px;
  }
  .devicesUl li {
    margin:0 10px;
  }
  .mapMobile {
    margin: 0;
    height: 300px;
    display: block;
  }
  .map {
    display: none;
  }
  .ContactPc,.newNav {
    display: none;
  }
  .content {
    padding: 0 10px;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
  }
  .Honor {
    margin: 10px;
  }
  .HonorPc {
    display: block;
    padding: 0 0 10px;
    width: 100%;
    box-sizing: border-box;
  }
  .address {
    display: none;
  }
  .CompanyMobile {
    display: block;
  }
  .ContactMobile {
    display: block;
    margin: 30px 10px;
  }
  .ContactMobileDiv div {
    padding-left: 20px;
    color: #fff;
  }
  .ContactMobileDiv {
    box-shadow: 5px 8px 10px 0px rgba(43, 48, 52, 0.3);
    background-color: rgba(65, 120, 190, 1);
    display: flex;
    align-items: center;
  }
  .rightImg,.botImg{
    display:none;
  }
  .mobileEditorAbout{
    line-height: 23px;
  }
  .honorParent div:nth-child(1){
    font-size:18px;
    line-height:17px;
  }
  .honorParent div:nth-child(2){
    line-height:14px;
  }
  .honorParent .titleLine2{
    height: 3px;
    width:30px;
    margin:5px auto 0;
  }
  .mobileCompHistor{
    padding-right:10px;
    margin-bottom: 35px;
  }
  .newHistory {
    display: none;
  }
}
</style>
